'use client';

import { Shield } from 'lucide-react';
import { OPEN_COOKIE_SETTINGS_EVENT } from '@/components/cookie-consent-banner';

export function CookieSettingsLink() {
  return (
    <button
      type="button"
      onClick={() => window.dispatchEvent(new Event(OPEN_COOKIE_SETTINGS_EVENT))}
      className="inline-flex items-center text-gray-400 hover:text-white transition-colors text-sm"
    >
      <Shield className="h-3 w-3 mr-1" />
      Cookie Settings
    </button>
  );
}
